/**
 * Self-hosted Jitsi Meet for live classes (meet.11plusmagic.co.uk).
 *
 * REACT_APP_JITSI_DOMAIN must match the backend JITSI_DOMAIN. JWT + recording
 * feature flags are enforced when Prosody/Jibri are configured on that host.
 */
export const JITSI_DOMAIN = process.env.REACT_APP_JITSI_DOMAIN || "meet.11plusmagic.co.uk";

export const JITSI_SCRIPT_URL = `https://${JITSI_DOMAIN}/external_api.js`;

/** In-app host meeting page (recording + whiteboard). */
export function tutorMeetingAppUrl(roomCode) {
  const origin = typeof window !== "undefined" ? window.location.origin : "";
  return `${origin}/tutor/meeting/${encodeURIComponent(roomCode)}`;
}

/** In-app student meeting page — hang up returns to the portal, not close3.html. */
export function studentMeetingAppUrl(roomCode) {
  const origin = typeof window !== "undefined" ? window.location.origin : "";
  return `${origin}/student/meeting/${encodeURIComponent(roomCode)}`;
}

/**
 * Direct Meet URL fallback. Prefer studentMeetingAppUrl / tutorMeetingAppUrl so leave
 * stays in our portal. enableClosePage=false reduces the post-hangup promo redirect.
 */
export function jitsiMeetingUrl(roomCode, displayName, { canRecord = false } = {}) {
  const base = `https://${JITSI_DOMAIN}/${roomCode}`;
  const parts = [];

  if (displayName && String(displayName).trim()) {
    parts.push(`userInfo.displayName=${encodeURIComponent(JSON.stringify(String(displayName).trim()))}`);
  }

  parts.push("config.enableClosePage=false");
  // Class roster comes from the tutor panel — never invite from inside Meet.
  parts.push("config.disableInviteFunctions=true");
  parts.push("interfaceConfig.HIDE_INVITE_MORE_HEADER=true");

  // Soft client-side lock: students must not see record controls. Use JWT on
  // the Meet host for hard enforcement.
  if (!canRecord) {
    parts.push("config.localRecording.enabled=false");
    parts.push("config.localRecording.disable=true");
    parts.push("config.fileRecordingsEnabled=false");
    parts.push("config.fileRecordingsServiceEnabled=false");
    parts.push("config.hiddenDomain=");
    parts.push(
      "interfaceConfig.TOOLBAR_BUTTONS=" +
        encodeURIComponent(
          JSON.stringify([
            "microphone",
            "camera",
            "desktop",
            "fullscreen",
            "fodeviceselection",
            "hangup",
            "chat",
            "raisehand",
            "tileview",
            "settings",
            "videoquality",
            "filmstrip",
          ])
        )
    );
  }

  return parts.length ? `${base}#${parts.join("&")}` : base;
}
